// How long a free table is free (Martin, Oct 2026): its next booking today, if it has one.
// The seat sheet says so before anyone is sat there for longer than the table has.

const LIVE = new Set(['confirmed', 'pending', 'arrived']);
const mins = (hhmm) => {
  const [h, m] = String(hhmm || '').split(':').map(Number);
  return Number.isFinite(h) && Number.isFinite(m) ? h * 60 + m : null;
};

/** The table's next booking from `nowHHMM` on, among `bookings` (today's), or null. */
export function nextBooking(bookings, tableId, nowHHMM) {
  const now = mins(nowHHMM) ?? 0;
  return (bookings || [])
    .filter((b) => b.table_id === tableId && LIVE.has(b.status) && (mins(b.time) ?? -1) >= now)
    .sort((a, b) => mins(a.time) - mins(b.time))[0] || null;
}

/** "2h 10m" / "45m" from now until `hhmm`. */
export function untilWords(hhmm, nowHHMM) {
  const gap = Math.max(0, (mins(hhmm) ?? 0) - (mins(nowHHMM) ?? 0));
  const h = Math.floor(gap / 60);
  const m = gap % 60;
  return h ? `${h}h${m ? ` ${m}m` : ''}` : `${m}m`;
}

/** Does a table seated now for `minutes` run past the booking at `hhmm`? */
export const runsPast = (minutes, hhmm, nowHHMM) => (mins(nowHHMM) ?? 0) + (Number(minutes) || 0) > (mins(hhmm) ?? Infinity);

/** "HH:MM" plus `minutes`, on the clock. */
export function clockPlus(nowHHMM, minutes) {
  const t = ((mins(nowHHMM) ?? 0) + (Number(minutes) || 0)) % (24 * 60);
  return `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
}
